<style src="./Relogin.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="relogin" v-if="getExpireStatus !== 'NO' && getExpireStatus !== 'PERMANENTLY' && $route.name !== 'Login'">
    <div class="relogin-header">
      <div class="logo">
        <img src="static/logo/logo-114x40.png" alt="Sinkr Logo">
      </div>
      <div class="info">
        <!-- <h4><strong>Desbloquear a tela</strong></h4> -->
      </div>
    </div>

    <div class="relogin-form">
      <h4>{{ shortUsername }}</h4>
      <form  v-on:submit.prevent="onSubmit">
        <password
          class="password-field"
          v-model="password"
          label="Senha"
          placeholder="Digite a senha"
          :validation="{group: 'login', required: true, min: 3, max: 6}">
          <icon-key slot="icon" />
        </password>


        <button class="btn-success">
          <icon-right-arrow />
        </button>
      </form>

      <div class="status-alert" v-if="reloginError">
        <span class="span-alert-small span-alert-danger">{{ reloginError }}</span>
      </div>

      <div class="bottom-command">
        <a class="command-logoff" @click.stop="doLogoff">fazer logoff desse uruário</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { Password } from '@/components/primitives'
import { IconKey, IconRightArrow } from '@/components/primitives/icons'

export default {
  name: 'Relogin',
  components: {
    Password,
    IconKey,
    IconRightArrow
  },
  data () {
    return {
      password: '',
      reloginError: false
    }
  },
  computed: {
    ...mapGetters({
      getExpireStatus: 'Login/GET_EXPIRE_STATUS',
      shortUsername: 'Login/GET_SHORT_USERNAME'
    })
  },
  methods: {
    onSubmit () {
      this.reloginError = false
      this.$store.dispatch('Login/DO_RELOGIN', {password: this.password})
        .catch((err) => {
          this.reloginError = err
        })
    },
    doLogoff () {
      this.$store.dispatch('Login/DO_LOGOFF', this.$router)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/relogin/Relogin.vue